import { omit } from 'remeda';
import z from 'zod';

import { PlateParagraph } from './Paragraph';
import { ELEMENT_TYPES } from '../constants';

export const Credit = z.object({
    ...omit(PlateParagraph.shape, ['id']),
    type: z.literal(ELEMENT_TYPES.CREDIT),
});

export type CreditElement = z.infer<typeof Credit>;
